import { useMemo } from 'react';
import { ILogisticsOrderDetailsAdditionalChargesDatagridProps } from '../../../types/commonDatagrid';
import { getLogisticsOrderDetailsAdditionalChargesColumns } from './columns';
import { CompactPhoneDatagrid } from '../CompactPhoneDatagrid.tsx';
import { Typography } from '@mui/material';

export const LogisticsOrderDetailsDatagridAdditionalCharge = ({
  data,
}: ILogisticsOrderDetailsAdditionalChargesDatagridProps) => {
  const columns = useMemo(() => getLogisticsOrderDetailsAdditionalChargesColumns(), []);
  const subtotal = data
    .reduce((sum: number, row: { total: string }) => sum + Number(row.total || 0), 0)
    .toFixed(2);

  return (
    <>
      <CompactPhoneDatagrid
        data={data}
        columns={columns}
        rowId="name"
        footer={
          <>
            <Typography fontSize={12}>Subtotal</Typography>
            <Typography fontSize={12} fontWeight={600}>
              ${subtotal}
            </Typography>
          </>
        }
      />
    </>
  );
};
